import { render, staticRenderFns } from "./auth-group-list.vue?vue&type=template&id=3c89acf0"
import script from "./auth-group-list.vue?vue&type=script&lang=js"
export * from "./auth-group-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports